// Named constants for custom window events used as a lightweight cross-widget
// message bus. Both the dispatch site (commandPalette) and listen sites
// (Sidebar, NavComponent, RelationshipSection) import from here, so a typo or
// rename is caught at compile time rather than silently breaking at runtime.

export const SIDEBAR_EVENTS = {
  expandAll: "sidebar:expand-all",
  collapseAll: "sidebar:collapse-all",
} as const;

export const WIDGET_EVENTS = {
  expandAll: "widgets:expand-all",
  collapseAll: "widgets:collapse-all",
} as const;

/**
 * Auth lifecycle events.
 *
 * Dispatched by the auth layer so that downstream features (e.g. teams cache,
 * TanStack Query cache) can react without creating an import dependency on auth
 * internals.
 *
 * Usage:
 *   // Dispatch (auth layer):
 *   window.dispatchEvent(new Event(AUTH_EVENTS.sessionCleared));
 *
 *   // Listen (teams layer):
 *   window.addEventListener(AUTH_EVENTS.sessionCleared, handler);
 */
export const AUTH_EVENTS = {
  /** Fired when the active session is cleared (logout or tenant switch). */
  sessionCleared: "auth:session-cleared",
} as const;
